import React, { useEffect, useState } from "react";
import GenericInvoiceTable from "../tables/GenericInvoiceTable";
import { purchaseConfig } from "../config/PurchaseInvoiceTableConfig";
import useApi from "../../hooks/useApi";

const PurchaseTable = ({
  items,
  onItemsChange,
  setShowSidebar,
  // setItemInfo,
  setCurrentLocation,
  extraFields = [],
  purchaseData,
  initialRowUnitOptions,
  isOtherCostEnabled,
  setIsOtherCostEnabled,
  otherCosts = [],
  setOtherCosts,
  BASE_URL,
  COMPANY_CODE,
  DEPARTMENT_NO,
  hideAddButton = true,
}) => {
  const { request, loading } = useApi();
  const [salesmanList, setSalesmanList] = useState([]);
  const fetchSalesmanList = async () => {
    const url = `${BASE_URL}/api/MasterCount/${COMPANY_CODE}/SALESPERSONLIST/-/${DEPARTMENT_NO}`;
    try {
      const response = await request({
        url: url,
        method: "GET",
        timeout: 10000,
      });
      console.log("Response", response);

      const mappedSalesmen = (response || []).map((s) => ({
        label: s.NAME,
        value: s.EMP_ID,
      }));

      setSalesmanList(mappedSalesmen);
    } catch (err) {
      console.error("Error loading data:", err);
      setSalesmanList([]);
    }
  };

  useEffect(() => {
    fetchSalesmanList();
  }, []);
  return (
    <GenericInvoiceTable
      items={items}
      onItemsChange={onItemsChange}
      setShowSidebar={setShowSidebar}
      // setItemInfo={setItemInfo}
      setCurrentLocation={setCurrentLocation}
      extraFields={extraFields}
      documentData={purchaseData}
      config={purchaseConfig}
      initialRowUnitOptions={initialRowUnitOptions}
      showOtherCostButton={true}
      onShowOtherCost={() => setIsOtherCostEnabled?.((v) => !v)}
      isOtherCostVisible={!!isOtherCostEnabled}
      otherCosts={otherCosts}
      setOtherCosts={setOtherCosts}
      salesmanOptions={salesmanList}
      hideAddButton={hideAddButton}
    />
  );
};

export default PurchaseTable;
